import React, { useState } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { Route, Routes, Navigate, BrowserRouter } from "react-router-dom";
import LineDetails from "./LineDetails";
import { connect, useSelector } from "react-redux";
import { RootState } from "./reducers";
import { useDispatch } from "react-redux";
import { getLineDetails, logout } from "./LineDetails/actions/index";
import ManageDevices from "./ManageDevices";
import "./index.scss";
import LineDelve from "./LineDelve";
import { Snackbar, SnackbarOrigin } from "@mui/material";
import { failureSavingName, updatedNameId } from "./common/NumberCard/action";
import SnackbarComponent from "./common/Snackbar";

import sdk from "./sdk";
import IdleTimer from "./IdleTimer";
import ModalDialog from "./common/ModalDialog/ModalDialog";
import { ModalObject } from "./common/NumberCard";
import { ComponentsContent } from "./common/NumberCard/NumberCardContent";
import Logout from "./logout";
import Retry from "./retry";
const mapStateToProps = (state: RootState) => {
  return { apiCallStatus: state?.app?.apiCallsStatus };
};

// interface Props {
//   apiCallStatus: any
// }

export interface RemainingTime {
  total: number;
  minutes: number;
  seconds: number;
}
export interface State extends SnackbarOrigin {
  open: boolean;
  snackMessage: string;
}

const App = () => {
  document.title = "T-Mobile";
  const dispatch = useDispatch();
  const isSaved = useSelector((state: RootState) => state.numberCard.saved);
  const message = useSelector(
    (state: RootState) => state.numberCard.snackMessage
  );
  const content = ComponentsContent?.Signout;

  const [openModal, setOpenModal] = React.useState(false);
  const [showRetryScreen, setShowRetryScreen] = React.useState(false);
  const [isAutoLogOut, setIsAutoLogOut] = React.useState(false);
  const [logingout, setLogingOut] = React.useState(false);
  const userManualLogingOut = window.location.pathname.includes("logout");
  const returnSingout = window.location.pathname.includes("signout");

  const handleLogOuteBtn = () => {
    //if(!isAutoLogOut){
    setLogingOut(true);
    setModelObject({
      ...modelObject,
      labelClose: !isAutoLogOut ? `logging out...` : `Log Out`,
      labelAction: isAutoLogOut ? `logging out...` : `Stay logged in (00:00)`,
    });
    //}
    dispatch(logout());
    setTimeout(function () {
      window.location.reload();
      //setLogingOut(false)
    }, 5000);
  };

  const handleModalAction = (_e: any, _reason: any) => {
    setOpenModal(false);
    setLogingOut(false);
    init();
  };
  const [modelObject, setModelObject] = useState<ModalObject>({
    ...content?.singingnout,
    closeAction: handleLogOuteBtn,
  });
  const [isTimeOut, setIsTimeOut] = useState(false);

  const [state, setState] = React.useState<State>({
    open: false,
    snackMessage: "",
    vertical: "bottom",
    horizontal: "center",
  });

  const { vertical, horizontal, open, snackMessage } = state;

  React.useEffect(() => {
    if (isSaved === true) {
      setState({ ...state, open: true, snackMessage: message });
      dispatch(failureSavingName({ isError: false }));
    }
  }, [isSaved]);

  React.useEffect(() => {
    console.log("build version 1.2");
    let authCount = sessionStorage.getItem("authCount") || 0;
    authCount = +authCount;
    const startApp = async () => {
      const response = await sdk.initiateApp();
      if (response && !response?.errors) {
        dispatch(getLineDetails());
      } else {
        if (authCount >= 3) {
          setShowRetryScreen(true);
        }
      }
    };
    if (!userManualLogingOut) {
      startApp();
      init();
    } else {
      sdk.redirectToEUILogout();
    }
  }, []);
  const init = () => {
    const timer = new IdleTimer({
      timeout: 1800,
      onTimeOut: () => {
        setIsTimeOut(true);
        setIsAutoLogOut(true);
        handleLogOuteBtn();
      },
      startCountDown: (time: any) => {
        if (!logingout) {
          setOpenModal(true);
          setModelObject({
            ...modelObject,
            labelAction: `Stay logged in (` + time + `)`,
          });
        }
      },
      timmer: (time: any) => {
        setModelObject({
          ...modelObject,
          labelAction: `Stay logged in (` + time + `)`,
        });
      },
    });
    return () => {
      timer.cleanUp();
    };
  };
  React.useEffect(() => {
    if (isTimeOut) {
      setIsTimeOut(false);
    }
  }, [isTimeOut]);

  const handleClose = () => {
    setState({ ...state, open: false, snackMessage: "" });
    dispatch(updatedNameId({ id: "" }));
  };

  if (returnSingout) {
    return <Logout />;
  } else if (showRetryScreen) {
    return <Retry />;
  } else {
    return (
      <div className="App">
        <BrowserRouter basename={process.env.REACT_APP_BASE_HREF}>
          <Routes>
            <Route path="/line-details" element={<LineDetails />} />
            <Route path="/manage-devices" element={<ManageDevices />} />
            <Route path="/line-delve" element={<LineDelve />} />
            <Route path="/signout" element={<Logout />} />
            <Route path="/retry" element={<Retry />} />
            <Route path="/" element={<Navigate to="/line-details" replace />} />
          </Routes>
        </BrowserRouter>
        <SnackbarComponent />
        {/* TODO: Move this to only login page, should not be rendered at all times within the application */}
        {/* <div className="appFooter">Build Version | Copyright T-Mobile 2020®</div> */}
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={open}
          onClose={handleClose}
          autoHideDuration={3000}
          message={snackMessage}
          key={vertical + horizontal}
          className="snackBar"
        />
        <ModalDialog
          openModal={openModal}
          modelObj={modelObject}
          dialogAction={handleModalAction}
          backDropClick={true}
        ></ModalDialog>
        <CssBaseline />
      </div>
    );
  }
};
export default connect(mapStateToProps, null)(App);
